export class Utilities{
    static merge(obj1:any, obj2:any):any{

        var data:any = {};
        
        if(obj1 == undefined || obj1 == null)  return obj2 == undefined ? null: obj2;

        if(obj2 !=undefined && obj2 !=null){
            Object.keys(obj1).forEach(key => { data[key] = obj1[key] });
            Object.keys(obj2).forEach(key => { data[key] = obj2[key] });
            return data;
        }

        return obj1;
    }

    static addStyleSheet( src : string, callback : Function ) {

        let d = document;
    
        let o = { callback: callback || function(){} };
    
        let s, t;
    
        if ( typeof src == "undefined" ) {
          return;
        }
        
        s = d.createElement("link");s.rel="stylesheet";s.async=1;s.charset="utf-8";s.href=src;
    
        if ( typeof o.callback == "function" ) {
    
          if ( d.addEventListener ) {
    
            s.addEventListener("load",function(){o.callback()},false);
    
          } else {
    
            // old IE support
    
            s.onreadystatechange=function(){if(this.readyState=="complete"||this.readyState=="loaded"){this.onreadystatechange=null;o.callback()}};
    
          }
    
        }
    
        t = d.getElementsByTagName("link")[1];
    
        t.parentNode.insertBefore(s, t);
    
      }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/utilities.ts